import { render, staticRenderFns } from "./TestiCard.vue?vue&type=template&id=7b5323ae&scoped=true"
import script from "./TestiCard.vue?vue&type=script&lang=js"
export * from "./TestiCard.vue?vue&type=script&lang=js"
import style0 from "./TestiCard.vue?vue&type=style&index=0&id=7b5323ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5323ae",
  null
  
)

export default component.exports